export const validationMsgs = {
  required: "This field is required.",
  email: "Please enter a valid email address.",
  equalTo: "Please enter the same value again.",
  termsConditions: "You must accept the terms and conditions.",
  minZero: "Please enter a number more than zero.",
  onlyNumber: "please enter only number.",
  complexPassword: "Must be complex, One Uppercase, One Lowercase, One Number and one special case Character",
  minNumber: (number: number) => `Please enter a number more than ${number}.`,
  maxNumber: (number: number) => `Please enter no more than ${number}.`,
  maxlength: (number: number) => `Please enter no more than ${number} characters.`,
  minlength: (number: number) => `Please enter at least ${number} characters.`,
};
